import React from 'react';
import ReactDOM from 'react-dom';
import '../resetPC.css';
import Layout from './layout';

/* eslint-disable */
const a = ['日', '一', '二', '三', '四', '五', '六'];
const week = new Date().getDay();
const currentTime = new Date();

allData.date = `${currentTime.getFullYear()}-${currentTime.getMonth() + 1}-${currentTime.getDate()}`;
allData.day = a[week];
ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
